import cn from 'classnames'
import { type GlobalTransactionHisType } from '../../../../../shared/types/GlobalTransactionHisType'
import { TransactionType } from '../../../../../shared/types/GlobalTranactionTypeEnum'
import { GlobalTransactionStatus } from '../../../../../shared/types/GlobalTransactionStatus'
import { type Transaction } from '../../../../../shared/proxies/transactionsProxy'

export function generateKey (recentTransaction: GlobalTransactionHisType): string {
  return `${recentTransaction.transactedAt}${recentTransaction.companyName}${recentTransaction.amountCents}`
}

export function determineTransactionColorClass (transaction: GlobalTransactionHisType | Transaction): string {
  if (transaction.status === GlobalTransactionStatus.Error) {
    return cn('text-right', 'text-gray-400')
  } else {
    return cn(
      'text-right',
      transaction.ppSslTransactionType === TransactionType.Return ? 'text-red-500' : 'text-emerald-700'
    )
  }
}
